import library from '../../../components/library.vue'
import search from '../../../components/search.vue'
import page from '../../../components/page.vue'
import {api} from "../../../common/config";
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {CommonUtil} from '../../../common/CommonUtil.js';
import {store} from '../../../store/store.js'

export default {
  name: "libraryIndex",
  data() {
    return {
      webType: store.webType,
      resource: '/search/searchlibrary',//高级搜索url
      libCodeList: [],
      pageNo: 1,
      pageCount: 6,
      ajaxStatus: false,
      totalPage: 1,
      searchContent: '',
      lngLat: '',
      locationCode: ''
    }
  },
  watch: {
    $route() {
      this.queryLibrary()
    }
  },
  beforeMount() {
    this.queryLibrary()
  },
  components: {
    search,
    library,
    page
  },
  mounted() {
    store.wrap.activeRouteName = '图书馆'
  },
  methods: {
    queryLibrary() {
      this.ajaxStatus = true;
      this.pageNo = this.$route.query.page || 1;
      this.lngLat = this.$route.query.latLng || store.localtionArea.latLng;
      this.locationCode = this.$route.query.code || store.chooseArea.code;

      var url = api.library.list.replace('{lngLat}', this.lngLat).replace('{pageCount}', this.pageCount).replace('{pageNo}', this.pageNo)
        .replace('{locationCode}', this.locationCode);
      ajaxUtil.ajaxJson(url, null, 'GET', (data) => {
        this.ajaxStatus = false;
        this.libCodeList = data.resultList;
        this.totalPage = data.totalPage;
        this.pageNo = data.pageNo;
      }, null, this);
    },
    changePage(pageNo) {
      CommonUtil.mergeQuery(this,{page: pageNo})
    },
    /*跳转页面*/
    toLibraryInfo(libId, libCode, libName, libLevel, logo, websiteUrl) {
      if (websiteUrl != null && websiteUrl.trim() != "") {
        window.open(websiteUrl);
        return;
      }
      this.$router.push({
        path: '/library',
        query: {
          libId: libId,
          fromSearch: 0,
          libCode: libCode,
          libName: libName,
          libLevel: libLevel,
          latLng: this.lngLat,
          locationCode: this.locationCode,
          logo: logo,
        }
      });
    },
    //搜索
    toSearch(value) {
      value = CommonUtil.Trim(value);
      if (value == "" || value.length == 0) {
        return;
      }
      this.$router.push({
        path: 'indexsearch',
        query: {searchStr: value, fromSearch: 1, type: 3, lngLat: this.lngLat, locationCode: this.locationCode}
      });
    },
    highSearch() {
      this.$router.push({path: '/searchlibrary', query: {type: 1, "fromSearch": 1}});
    }
  }
}